import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid, Field } from 'redux-form'
import { Alert, Button, Row, Col } from 'react-bootstrap'

import * as actions from '../../../actions'
import { FORM_ANULACION_INGRESO } from '../../../../../config/forms'
import { renderTextField } from '../../../../Forms/fieldRenderers'
import {
  required,
  getNumericValidator
} from '../../../../Forms/fieldValidators'

const numeric12 = getNumericValidator(9, 12)
class AnulacionIngreso0 extends Component {
  render () {
    const {
      onSubmit,
      invalid
    } = this.props

    return (
      <div>
        <Row>
          <Col md={3} />
          <Col md={6}>
            <Alert variant='info'>
              <Alert.Heading>Importante!!</Alert.Heading>
              Solo se pueden eliminar Cartas de Porte que se encuentren en la Playa de Camiones.
            </Alert>
          </Col>
          <Col md={3} />
        </Row>
        <Row className='justify-content-md-center'>
          <Col md={12}>
            <Field
              className='cpa-grande'
              name='numero'
              type='text'
              label='Número'
              component={renderTextField}
              autoFocus
              validate={[required, numeric12]}
              placeholder='10200000000'
            />
          </Col>
        </Row>
        <br />
        <Button
          variant='primary'
          size='lg'
          onClick={() => onSubmit()}
          disabled={invalid}
        >Siguiente</Button>
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  invalid: isInvalid(FORM_ANULACION_INGRESO)(state)
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_ANULACION_INGRESO,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})

export default withRedux(withReduxForm(AnulacionIngreso0))
